import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Footer = ({ settings }) => {
  const [egg, setEgg] = useState(false);

  const triggerEgg = () => {
    setEgg(true);
    setTimeout(() => setEgg(false), 3000);
  };

  return (
    <footer data-testid="footer" className="relative z-10 bg-[#0A0A0A] border-t border-[#1a1a1a] pt-16 overflow-hidden">
      <div className="px-6 md:px-12 lg:px-24 flex flex-wrap items-center justify-between gap-6 pb-10">
        <div className="flex gap-6 text-xs tracking-[0.25em] uppercase">
          {[["TikTok", settings.tiktok], ["Instagram", settings.instagram], ["YouTube", settings.youtube], ["X", settings.x]].map(([name, url]) =>
            url ? (
              <a key={name} href={url} target="_blank" rel="noreferrer" className="text-[#525252] hover:text-[#C1121F] transition-colors">
                {name}
              </a>
            ) : null
          )}
        </div>
        <p className="text-xs text-[#525252]">
          © 2026 cellat36pr.com — Tüm hakları saklıdır ·{" "}
          <button data-testid="footer-easter-egg" onClick={triggerEgg} className="text-[#3E5C3A] hover:text-[#C1121F] transition-colors font-mono" aria-label="36">
            36
          </button>
        </p>
      </div>
      <AnimatePresence>
        {egg && (
          <motion.div
            data-testid="easter-egg-reveal"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="px-6 md:px-12 lg:px-24 pb-6 text-xs text-[#3E5C3A] font-mono"
          >
            36 = Kars. Her şey Sarıkamış'ta başladı. 🐍
          </motion.div>
        )}
      </AnimatePresence>
      <div className="relative h-[18vw] min-h-[90px] overflow-hidden select-none" aria-hidden="true">
        <p
          className="font-blackletter text-[#141414] absolute left-1/2 -translate-x-1/2 whitespace-nowrap leading-none"
          style={{ fontSize: "22vw", bottom: "-0.28em" }}
        >
          CELLAT36
        </p>
      </div>
    </footer>
  );
};
